// Keep server-redacted content locked; the add-on gates only inbound guest messages.
export const isMessageLocked = (message, messagingLocked) => Boolean(
  message && (message.locked || (messagingLocked && !message.internal &&
    !message.fromHotel && !message.fromAI)),
);
